export default function () {
  const menu = document.querySelector('#mobile-menu');
  const openBtn = document.querySelector('#mobile-menu-open');
  const closeBtn = document.querySelector('#mobile-menu-close');
  const menuLinks = menu ? menu.querySelectorAll('a') : [];
  const inertEls = ['main', 'footer'];

  if(!menu || !openBtn) return;

  const openMenu = () => {
    menu.classList.add('active');
    menu.classList.add('transition-transform', 'ease-out', 'duration-300');
    menu.removeAttribute('inert');
    closeBtn.classList.remove('hidden');
    openBtn.classList.add('hidden');
    document.body.classList.add('menu-is-open');

    closeBtn.focus();

    inertEls.forEach(el => {
      document.querySelector(el).setAttribute('inert', '');
    });
  };

  const closeMenu = () => {
    menu.classList.remove('active');
    menu.setAttribute('inert', '');
    closeBtn.classList.add('hidden');
    openBtn.classList.remove('hidden');
    document.body.classList.remove('menu-is-open');

    openBtn.focus();

    inertEls.forEach(el => {
      document.querySelector(el).removeAttribute('inert', '');
    });
  };

  openBtn.addEventListener("click", () => {
    openMenu();
  });

  closeBtn.addEventListener("click", () => {
    closeMenu();
  });

  menuLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeMenu();
    });
  });
}
